module.exports = __webpack_public_path__ + "../resources/img/ic_re_hydro_unit1_p2.b919e70c.svg";